<template>
  <div id="ResBall">
    <div class="ssc" v-if="showType.includes(type)">
      <!-- || dataSource.issueId==dataSource.lastResultIssueID 当前期数等于最后一期数 代表当前彩种封盘，正常显示开奖球号 -->
      <span
        v-if="showTime != '开奖中'"
        :style="{'background-color':(it=='19'||it=='20')?'#e44c3f':''}"
        v-for="(it,i) in showBall"
        :key="i"
      >{{it}}</span>
      <lottery v-if="showTime == '开奖中'" v-for="(it,i) in showBall" :key="i" :ball="it"></lottery>
    </div>
    <ul class="pk10" v-if="type == 'PK10' || type == 'nn'">
      <li v-if="showTime != '开奖中'  " :class="'c'+it" v-for="(it,i) in showBall" :key="i"></li>
      <li v-if="showTime == '开奖中'" :class="'c'+it" v-for="(it,i) in showBall1" :key="i"></li>
    </ul>
    <div class="xyrb" v-if="type == 'xyrb'">
      <span v-if="showTime != '开奖中' " class="ball">{{showBall[0]}}</span>
      <lottery v-else :ball="showBall[0]"></lottery>
      <span>+</span>
      <span v-if="showTime != '开奖中'" class="ball">{{showBall[1]}}</span>
      <lottery v-else :ball="showBall[1]"></lottery>
      <span>+</span>
      <span v-if="showTime != '开奖中'" class="ball">{{showBall[2]}}</span>
      <lottery v-else :ball="showBall[2]"></lottery>
      <span>=</span>
      <span v-if="showTime != '开奖中'" class="ball red">{{count}}</span>
      <lottery v-else :ball="count"></lottery>
    </div>
    <div class="lhc" v-if="type == 'lhc'">
      <template v-for="(it,i) in showBall">
        <span :class="it | lhcBgColor">{{it}}</span>
        <em v-if="i == 5">+</em>
      </template>
    </div>
    <div class="ks" v-if="type == 'ks'">
      <span :class="'c'+it" v-for="(it,i) in showBall" :key="i"></span>
    </div>
  </div>
</template>
<script>
import { LHC_BALL_BG_COLOR } from "../../helpers/BETTYPEDATA.js";
import lottery from "../Lottery";

export default {
  name: "ResBall",
  components: {
    lottery
  },
  props: ["type", "dataSource", "showTime"],
  data() {
    return {
      showType: ["ssc", "three", "choose5", "hpten"],
      changeBall: "",
      interval: null,
      showBall1: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]
    };
  },
  computed: {
    showBall() {
      return this.dataSource.lastResult
        ? this.dataSource.lastResult.split(",")
        : [];
    },
    count() {
      return this.dataSource.lastResult
        ? this.dataSource.lastResult
            .split(",")
            .reduce((a, b) => Number(a) + Number(b))
        : 0;
    }
  },
  filters: {
    lhcBgColor(it) {
      if (~LHC_BALL_BG_COLOR[0].indexOf(it)) {
        return "red";
      } else if (~LHC_BALL_BG_COLOR[1].indexOf(it)) {
        return "blue";
      } else if (~LHC_BALL_BG_COLOR[2].indexOf(it)) {
        return "green";
      } else {
        return "";
      }
    }
  },

  created() {
    // console.log("datasource", this.dataSource);
    this.openPk();
  },

  methods: {
    openPk() {
      this.interval = setInterval(() => {
        this.showBall1.push("" + ((Number(this.showBall1[0]) + 1) % 10));
        this.showBall1.splice(0, 1);
      }, 100);
    }
  },
  destroyed() {
    clearInterval(this.interval);
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/ResBall/index.vue